import React from 'react'
import { useTranslation } from 'react-i18next'
import { getIn } from 'formik'
import PropTypes from 'prop-types'
import { format } from 'date-fns'

import Checkbox from '../../../../../../../../../components/Form/Checkbox'

import { getPeriodKeyFromFileRowIdAndCustomDate } from '../../../../../../../../../pages/MediaOrderSummary/MediaOrderSummaryContent/RequestedFilesSection/helpers'

import { PERIOD_IS_SELECTED, SELECTED_PERIODS } from '../../../../fields'
import { DATES_FORMAT_FULL_YEAR } from '../../../../../../../../../constants/dates'

import useStyles from './styles'

function FileRequestedDatesFields({ values, setFieldValue, requestedPeriods }) {
  const classes = useStyles()
  const { t } = useTranslation()

  const filePeriods = requestedPeriods.map(file => {
    const { requested_file, uploaded_files } = file
    const periodKey = getPeriodKeyFromFileRowIdAndCustomDate({
      fileId: requested_file.id,
      bookedMediaId: requested_file.booked_media_id,
      customDate: requested_file.custom_date && requested_file.date_start
    })

    return {
      uploaded_files: uploaded_files,
      name: `[${SELECTED_PERIODS}][${periodKey}].[${PERIOD_IS_SELECTED}]`,
      title: format(new Date(requested_file.date_start), DATES_FORMAT_FULL_YEAR)
    }
  })

  return filePeriods.map(({ name, title, uploaded_files }) => {
    const isFileAlreadyUploaded = !!uploaded_files.length

    return (
      <Checkbox
        key={name}
        id={`checkbox_${name}`}
        title={t(title)}
        isLarge
        checked={!!getIn(values, name)}
        onCheck={() => {
          setFieldValue(name, !getIn(values, name))
        }}
        className={classes.periodCheckbox}
        pseudoDisabled={isFileAlreadyUploaded}
      >
        {isFileAlreadyUploaded && <span className={classes.alreadyUploadedDescription}>({t('already uploaded')})</span>}
      </Checkbox>
    )
  })
}

FileRequestedDatesFields.propTypes = {
  values: PropTypes.object,
  setFieldValue: PropTypes.func,
  requestedPeriods: PropTypes.array
}

export default FileRequestedDatesFields
